import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.js";
import ServerDropdownItem_vue_vue_type_script_setup_true_lang_default from "./ServerDropdownItem.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                       */
//#region src/v2/components/server/ServerDropdownItem.vue
var ServerDropdownItem_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ServerDropdownItem_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-9775eaaf"]]);
//#endregion
export { ServerDropdownItem_default as default };

//# sourceMappingURL=ServerDropdownItem.vue.js.map